import type { PageContent } from "../types";

export const p_2023_seo_lessons_and_forward_view: PageContent = {
  slug: "2023-seo-lessons-and-forward-view",
  title: `2023 SEO Lessons and Forward View | Phil Carr SEO Consultant`,
  description: `From multiple core updates to the arrival of generative AI, 2023 reshaped the digital landscape. It became clear that search engines value…`,
  date: "",
  lastUpdated: "2026-04-14",
  body: `# 2023 SEO Lessons and Forward View

![2023 SEO Lessons and Forward View featured image](/images/blog/generated/2023-seo-lessons-and-forward-view.jpg)

**Published:** June 15, 2023

## A Year of Transformation

From multiple core updates to the arrival of generative AI, 2023 reshaped the digital landscape. It became clear that search engines value authenticity and depth above all else, and that generative experiences are pushing content towards direct answers and more complex questions.

Voice search continued to rise in importance, local SEO matured with refined ranking factors, and zero‑click features forced marketers to rethink how they measure success. The hidden gems and helpful content updates emphasised that passion and expertise can triumph over sheer domain authority.

## Looking Ahead

These changes set the stage for 2024 and beyond. Expect AI to become more integrated into everyday search, with multimodal results combining text, images, video, and voice.

Emphasis on experience—both user experience and the real‑world experience behind your content—will only grow. Structured data, conversational optimisation, and cross‑channel engagement will be table stakes.

The businesses that thrive will be those that embrace change, stay close to their audiences, and invest in quality over quick wins.

## What businesses should take from 2023

The biggest lesson was that shallow content became harder to defend. Pages needed a clearer purpose, stronger evidence, and more useful answers. Generic articles written only to target a keyword were less convincing than pages that showed real experience, practical examples, and a connection to the wider service journey.

For local and service-based businesses, this meant the core website mattered more than ever. A helpful blog can support visibility, but the service pages, contact journey, location signals, and conversion paths still decide whether search traffic becomes revenue.

## Priorities for the next phase

- Review older content for accuracy, depth, and commercial relevance.
- Consolidate overlapping posts that compete for the same intent.
- Strengthen service pages before chasing more top-of-funnel traffic.
- Use structured headings and concise answers for AI-influenced search results.
- Measure how content assists enquiries, not only whether it ranks.

## SEO Takeaways and Next Steps

By reflecting on the successes and challenges of 2023, you can position yourself for the future. If you’d like personalised guidance on preparing your SEO strategy for the coming years, email info@phil‑carr.co.uk or call 01226 697 325.

I can help you navigate whatever the next wave of updates brings.

If you need help with your SEO strategy, get in touch by emailing [info@phil-carr.co.uk](mailto:info@phil-carr.co.uk) or calling 01226 697 325.

## Update — April 2026

Reviewed in April 2026 against the last two core update roll-outs. The bit that's aged best is the emphasis on primary content quality over surface tweaks; the bit worth re-reading is the section on recovery timelines — they've stretched to closer to two full crawl cycles.

## About the author

Phil Carr is an SEO consultant and web strategist focused on helping businesses
grow through technical optimisation, content strategy, and data-driven decision making. His
work combines hands-on experience with ongoing research into algorithm updates and emerging
search trends.

[Read Phil’s bio](/#authorModal)

## Other News Articles

[![2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns featured image](/images/blog/generated/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns.jpg)](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

### [2024 Algorithm Updates – Navigating a Year of Core Changes and Spam Crackdowns](/blog/2024-algorithm-updates-navigating-a-year-of-core-changes-and-spam-crackdowns)

[![A Practical Plan for AI-Driven Search – A Ninety Day Playbook featured image](/images/blog/generated/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook.jpg)](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

### [A Practical Plan for AI-Driven Search – A Ninety Day Playbook](/blog/a-practical-plan-for-ai-driven-search-a-ninety-day-playbook)

[![Looking Ahead: Lessons from 2024 for the Future featured image](/images/blog/generated/looking-ahead-lessons-from-2024-for-the-future.jpg)](/blog/looking-ahead-lessons-from-2024-for-the-future)

### [Looking Ahead: Lessons from 2024 for the Future](/blog/looking-ahead-lessons-from-2024-for-the-future)

[![Lessons from Google’s 2025 Algorithm Updates featured image](/images/blog/generated/lessons-from-google-s-2025-algorithm-updates.jpg)](/blog/lessons-from-google-s-2025-algorithm-updates)

### [Lessons from Google’s 2025 Algorithm Updates](/blog/lessons-from-google-s-2025-algorithm-updates)

We use cookies to improve your experience, analyse site traffic, and understand how you interact with
our content. Read our [cookie policy](/cookies) to learn more.

Reject optionalAccept cookies [Privacy policy](/privacy-policy)

reCAPTCHA

Recaptcha requires verification.

protected by **reCAPTCHA**`,
};
